export default {
  props: ['item', 'theme'],

  computed: {
    animation: {
      get() {
        return this.getField('animation');
      },

      set(animation) {
        this.setField('animation', animation);
      },
    },

    panelFields() {
      return {
        ...this.item.fields,
        ...this.panel.settings,
        ...(this.editing.fields || {}),
      };
    },
  },

  methods: {
    setField(field, value, saveProduction) {
      if (!this.item.fields[field]) {
        this.$set(this.item.fields, field, value);
      } else {
        this.item.fields[field] = value;
      }

      if (!saveProduction || !['qrCodeUrl', 'showQrCode'].includes(field)) {
        return;
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const timeline of this.$store.state.production.production.timeline) {
        if (timeline._id === this.item._id) {
          timeline.fields = this.item.fields;
        }
      }
    },

    getField(field) {
      return field in this.item.fields
        ? this.item.fields[field] : this.theme?.settings?.[field];
    },

    getNiceTime(time) {
      return Math.floor(time / 1000);
    },

    setNiceTime(field, ms) {
      this.setField(field, ms * 1000);
    },
  },
};
